
import {createAsyncThunk} from "@reduxjs/toolkit";
import api from "../../../api";
import {RootState} from "../../../store";

export const fetchAll = createAsyncThunk(
  'file/fetchAll',
  async (a, thunk) => {
    const state = thunk.getState() as RootState;
    return api(thunk.dispatch).file.fetchAll([state.identity.id ?? "", state.identity.code ?? ""]);
  }
)
